import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { Check, Clock, UserPlus, Users } from "lucide-react";
import { Avatar } from "../Avatar";
import { ChatConversationSchemaType, RealEstateConversationAtributesSchemaType } from "../../../api/schemas";
import { SearchUserSchemaType } from "@/components/modules/user/api/schemas";
import { useChatHeader } from "./useChatHeader";
type Props = {
  userName?: string;
  conversation?: ChatConversationSchemaType;
  user?: SearchUserSchemaType;
  realEstateConversationAtributes?: RealEstateConversationAtributesSchemaType;
  isOtherUserTyping?: boolean;
};
export function ChatHeader(t0) {
  const $ = _c(43);
  const {
    userName,
    conversation,
    user,
    realEstateConversationAtributes,
    isOtherUserTyping
  } = t0;
  const tConn = useTranslations("modules.connections");
  let t1;
  if ($[0] !== conversation || $[1] !== realEstateConversationAtributes || $[2] !== user || $[3] !== userName) {
    t1 = {
      userName,
      conversation,
      user,
      realEstateConversationAtributes
    };
    $[0] = conversation;
    $[1] = realEstateConversationAtributes;
    $[2] = user;
    $[3] = userName;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    isMobile,
    closeModal,
    hasRealEstate,
    realEstateTitle,
    profileHref,
    friendshipState,
    sendFriendRequest,
    isCreatingRequest
  } = useChatHeader(t1);
  const t2 = isMobile ? "small" : "medium";
  const t3 = realEstateConversationAtributes?.image;
  let t4;
  if ($[5] !== conversation || $[6] !== t2 || $[7] !== t3 || $[8] !== user) {
    t4 = <Avatar size={t2} user={user} conversation={conversation} realEstateImage={t3} data-sentry-element="Avatar" data-sentry-source-file="ChatHeader.tsx" />;
    $[5] = conversation;
    $[6] = t2;
    $[7] = t3;
    $[8] = user;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== closeModal || $[11] !== profileHref || $[12] !== userName) {
    t5 = profileHref ? <Link href={profileHref} onClick={() => closeModal()} className="text-sm sm:text-md font-semibold text-foreground cursor-pointer hover:text-foreground-strong transition-colors w-fit">{userName}</Link> : <span className="text-sm sm:text-md font-semibold">{userName}</span>;
    $[10] = closeModal;
    $[11] = profileHref;
    $[12] = userName;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isOtherUserTyping) {
    t6 = isOtherUserTyping && <span className="text-xs text-muted-foreground italic">a escrever...</span>;
    $[14] = isOtherUserTyping;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== hasRealEstate || $[17] !== isOtherUserTyping || $[18] !== realEstateTitle) {
    t7 = hasRealEstate && !isOtherUserTyping && <span className="text-xs text-muted-foreground">{realEstateTitle}</span>;
    $[16] = hasRealEstate;
    $[17] = isOtherUserTyping;
    $[18] = realEstateTitle;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="flex flex-col justify-center">{t5}{t6}{t7}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== friendshipState || $[25] !== tConn) {
    t9 = friendshipState === "friends" && <span className="inline-flex items-center gap-1 rounded-full bg-success-soft border border-success/30 text-success text-[10px] px-2 py-0.5"><Users className="h-2.5 w-2.5" />{tConn("friend")}</span>;
    $[24] = friendshipState;
    $[25] = tConn;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== friendshipState || $[28] !== tConn) {
    t10 = friendshipState === "pending" && <span className="inline-flex items-center gap-1 rounded-full bg-muted border border-border text-foreground-secondary text-[10px] px-2 py-0.5"><Clock className="h-2.5 w-2.5" />{tConn("requestPending")}</span>;
    $[27] = friendshipState;
    $[28] = tConn;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== friendshipState || $[31] !== isCreatingRequest || $[32] !== sendFriendRequest || $[33] !== tConn) {
    t11 = friendshipState === "none" && <button type="button" onClick={sendFriendRequest} disabled={isCreatingRequest} className="inline-flex items-center gap-1 rounded-full border border-primary text-primary text-[10px] px-2 py-0.5 hover:bg-primary/5 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">{isCreatingRequest ? <Check className="h-2.5 w-2.5" /> : <UserPlus className="h-2.5 w-2.5" />}{tConn("addFriend")}</button>;
    $[30] = friendshipState;
    $[31] = isCreatingRequest;
    $[32] = sendFriendRequest;
    $[33] = tConn;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t9) {
    t12 = <div className="ml-auto mr-10 sm:mr-12">{t9}{t10}{t11}</div>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t9;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t12 || $[40] !== t4 || $[41] !== t8) {
    t13 = <div className="border-b" data-sentry-component="ChatHeader" data-sentry-source-file="ChatHeader.tsx"><div className="relative flex items-center gap-2 sm:gap-4 p-0.5 sm:p-4 ml-10 sm:ml-0 ">{t4}{t8}{t12}</div></div>;
    $[39] = t12;
    $[40] = t4;
    $[41] = t8;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  return t13;
}